<template>
  <div>
    <template v-if="showNoPoliciesExist">
      <v-col cols="12">
        <v-card>
          <v-card-text>No Policies Found</v-card-text>
        </v-card>
      </v-col>
    </template>
    <template v-else>
      <v-col v-if="inactive && !noPoliciesExist" cols="12" class="py-0">
        <span class="title">Inactive Policies</span>
      </v-col>
      <v-col v-if="archived" cols="12" class="py-0">
        <span class="title">Archived Policies</span>
      </v-col>
      <v-col v-for="(p, idx) in policies" :key="`P + ${idx}`" cols="12" class="py-1">
        <PolicySummary :policy="p" :archived="archived" />
      </v-col>
      <v-col v-if="policies.length < totalCount" cols="12">
        <div class="caption text-center px-4">
          <v-btn color="blue2" outlined block @click="getPolicies()">Load More</v-btn>
        </div>
      </v-col>
        <v-col v-if="archived && policies.length === 0" cols="12">
        <div class="caption text-center px-4">
          <v-btn color="blue2" outlined block @click="getPolicies()">Load Archived</v-btn>
        </div>
      </v-col>
    </template>
  </div>
</template>

<style>
</style>

<script>
import PolicySummary from '@/components/Client/Policies/PolicySummary.vue';
import analyticsService from '@/services/shared/analyticsService.js';
import apiService from '@/services/shared/agentPortalApiService.js';
import { mapActions } from 'vuex';

export default {
  name: 'PolicySummaryList',
  components: {
    PolicySummary
  },
  props: {
    inactive: {
      required: false,
      type: Boolean,
      default: false
    },
    archived: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      policies: [],
      totalCount: 0
    };
  },
  computed: {
    clientId: function () {
      return this.$route.params.clientId;
    },
    noPoliciesExist: function () {
      return !this.policies || this.policies.length === 0;
    },
    showNoPoliciesExist: function () {
      if (this.archived) return false;
      return this.noPoliciesExist && !this.inactive;
    }
  },
  watch: {
    clientId: async function () {
      // Client id has changed? Go fetch more policies
      if (!this.archived) {
        await this.getPolicies();
      }
    }
  },
  created: async function () {
    if (((this.policies || null) === null || this.policies.length === 0) && !this.archived) {
      await this.getPolicies();
    }
  },
  methods: {
    ...mapActions(['setError']),
    getPolicies: async function () {
      if (this.policies.length > 0) {
        analyticsService.sendEvent(this.$gtag, 'Load More', 'Client', 'Policies Load More');
      }
      var rs = await apiService.getPolicies(this.clientId, this.policies.length, !this.inactive, this.archived);
      if (rs.code === 0) {
        this.totalCount = rs.data[0].totalCount;

        if ((this.policies || null) === null) {
          this.policies = rs.data[0].data;
        } else {
          this.policies = this.policies.concat(rs.data[0].data);
        }
      } else {
        this.setError(rs.message);
      }
    }
  }
};
</script>
